import { BluetoothDataFormat } from "../../../store/bluetooth/bluetooth-data-format";
import { IProzessDto, IFunktionConfigurationDto } from "../../../api/backend-api-v7";
import {
  ProzessEventOperationTypes,
  ProzessInputData,
} from "../../../store/prozess-events/prozess-events.actions";

export interface ConnectedState {
  tierIdent: BluetoothDataFormat | undefined;
  givenData: ProzessInputData | undefined;
  prevRecordId: string;
  isManuallyEmpty: boolean;
  shouldCreateProzessEventForMultipleProzess: boolean;
  editedValue: string | undefined;
  isEditing: boolean;
}

export interface ConnectedDispatch {
  onChanged: (prozessInputData: ProzessInputData) => void;
  givenDataApplied: (workflowId: number) => void;
  resetTierIdentData: () => void;
}

export interface OwnProps {
  prozess: IProzessDto;
  recordId: string;
  manualInput: boolean;
  shouldValidate: boolean;
  setIsValidationError: (isError: boolean) => void;
  funktionId: number;
  funktionConfiguration: IFunktionConfigurationDto;
}

export interface Props extends OwnProps, ConnectedState, ConnectedDispatch {}

export interface TierIdentState {
  tierIdent: string;
  isError: boolean;
  isValid: boolean;
  isProzessEdited?: boolean;
}

export interface TierIdentAction {
  type: TierIdentActionType;
  payload: {
    value: string | string[] | undefined;
    isRequired?: boolean;
    shouldKeepValue?: boolean;
    status: ProzessEventOperationTypes;
    isValid?: boolean;
    isProzessEdited?: boolean;
  };
}

export enum TierIdentActionType {
  INIT,
  PROZESS_DATA_CHANGED,
  PROZESS_DATA_EDITED,
  RESET,
}
